import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ForBusiness } from '../model/for-business.model';
import { ForBusinessService } from '../services/for-business.service';

@Component({
  selector: 'app-for-business',
  templateUrl: './for-business.component.html',
  styleUrls: ['./for-business.component.css']
})
export class ForBusinessComponent implements OnInit {
  ngOnInit(): void {
  }

  name!:string;
  email!:string;
  phoneno!:string;
  alternativeno!:string;
  aadharno!:string;
  address!:string;
  forBusiness: ForBusiness = new ForBusiness();
  submitted = false;
  error!:string;
  success!:string;
  constructor(private forBusinessService: ForBusinessService,private router:Router,private activatedRoute: ActivatedRoute) {
    this.activatedRoute.queryParams.subscribe(params => {
      let errors = params[':error'];
      this.error = errors;
      let successs = params[':success'];
      this.success = successs;
    });
  }

  onBusinessRequestSubmit(){
    if(!this.forBusiness.name&&!this.forBusiness.email&&!this.forBusiness.phoneno&&!this.forBusiness.aadharno&&!this.forBusiness.address){
     this.router.navigateByUrl('/beingagent?:error=Fill All Required Fields');
    }else{
   this.forBusinessService.create(this.forBusiness).then(() => {
     console.log('Request Submitted successfully!');
     this.submitted = true;
     if(this.submitted){
       this.router.navigateByUrl('/beingagent?:success=Request Submitted successfully! Thank You');
     }
   });
 }
 }
}

